import axios from 'axios'
import { CommonSampleClassificationLaboratoryParameterResponse, CommonSampleClassificationParams, CommonSampleClassificationSubrequestFormDetailResponse } from '@/api/resources/common/sample-classification/sample-classification.model'
import {
    CommonSampleTypeResponse,
    SampleTypeWithCaseTypesResponse
} from '@/api/services/common/sample-type/common-sample-type.dto'
import { CommonMostLikelyMorphologicCodeResponse } from '@/api/services/common/most-likely-morphologic-code/common-most-likely-morphologic-code.dto'
import { CommonTopographicCodeResponse } from '@/api/services/common/topographic-code/common-topographic-code.dto'
import { CommonProcedureResponse } from '@/api/services/common/procedure/common-procedure.dto'
import { orderBy } from 'lodash'
import { TextNormalization } from '@/shared/util/text-normalization'

class CommonSampleClassificationService {
    async getCommonSampleTypeSampleClassificationsByLaboratory(params: Partial<CommonSampleClassificationParams>): Promise<CommonSampleTypeResponse[]> {
        const response = await axios.get<CommonSampleTypeResponse[]>(`/sampleClassifications/sampleTypes`, { params })
        return orderBy(response.data, element => TextNormalization.removeDiacritics(element.description), ['asc'])
    }

    async getCommonSampleTypeWithCaseTypesSampleClassificationsByLaboratory(params: Partial<CommonSampleClassificationParams>): Promise<SampleTypeWithCaseTypesResponse[]> {
        const response = await axios.get<SampleTypeWithCaseTypesResponse[]>(`/sampleClassifications/sampleTypesWithCaseTypes`, { params })
        return orderBy(response.data, element => TextNormalization.removeDiacritics(element.description), ['asc'])
    }

    async getCommonMostLikelyMorphologicCodesSampleClassificationsByLaboratory(params: Partial<CommonSampleClassificationParams>): Promise<CommonMostLikelyMorphologicCodeResponse[]> {
        const response = await axios.get<CommonMostLikelyMorphologicCodeResponse[]>(`/sampleClassifications/mostLikelyMorphologicCodes`, { params })
        return orderBy(response.data, element => TextNormalization.removeDiacritics(element.description), ['asc'])
    }

    async getCommonTopographicCodesSampleClassificationsByLaboratory(params: Partial<CommonSampleClassificationParams>): Promise<CommonTopographicCodeResponse[]> {
        const response = await axios.get<CommonTopographicCodeResponse[]>(`/sampleClassifications/topographicCodes`, { params })
        return orderBy(response.data, element => TextNormalization.removeDiacritics(element.description), ['asc'])
    }

    async getCommonProceduresSampleClassificationsByLaboratory(params: Partial<CommonSampleClassificationParams>): Promise<CommonProcedureResponse[]> {
        const response = await axios.get<CommonProcedureResponse[]>(`/sampleClassifications/procedures`, { params })
        return orderBy(response.data, element => TextNormalization.removeDiacritics(element.description), ['asc'])
    }

    async getCommonFormsSampleClassificationsByLaboratory(params: Partial<CommonSampleClassificationParams>): Promise<CommonSampleClassificationSubrequestFormDetailResponse> {
        const response = await axios.get<CommonSampleClassificationSubrequestFormDetailResponse>(`/sampleClassifications/forms`, { params })
        return response.data
    }

    async getCommonParametersLaboratorySampleClassifications(laboratoryId: number): Promise<CommonSampleClassificationLaboratoryParameterResponse[]> {
        const response = await axios.get<CommonSampleClassificationLaboratoryParameterResponse[]>(`/laboratories/${laboratoryId}/sampleClassifications/parameters`)
        return response.data
    }
}

export const commonSampleClassificationService = new CommonSampleClassificationService()
